import { DetailsModalPage } from '@modules/Admin/components/DetailsModal/DetailsModal';
import { SessionTab } from '@modules/Admin/components/DetailsModal/SessionDetailsPage/SessionTabsSection/SessionTabsSection';
import { useState } from 'react';
import { MentorTab } from '../components/DetailsModal/MentorDetailsPage/MentorTabsSection/MentorTabsSection';
import { StudentTab } from '../components/DetailsModal/StudentDetailsPage/StudentTabsSection/StudentTabsSection';

export type ActiveModalView =
  | { page?: Extract<DetailsModalPage, 'session'>; tab?: SessionTab }
  | { page?: Extract<DetailsModalPage, 'student'>; tab?: StudentTab }
  | { page?: Extract<DetailsModalPage, 'mentor'>; tab?: MentorTab }
  | { page?: Extract<DetailsModalPage, 'enrollment'>; tab?: undefined };

const useDetailsModal = (initialView: ActiveModalView) => {
  const [activeModalView, setActiveModalView] = useState<ActiveModalView>(initialView);
  const [isOpen, setIsOpen] = useState(false);
  const [mentorId, setMentorId] = useState<string | undefined>();
  const [studentId, setStudentId] = useState<string | undefined>();
  const [sessionId, setSessionId] = useState<string | undefined>();
  const [enrollmentId, setEnrollmentId] = useState<string | undefined>();

  const openModal = (
    view: ActiveModalView,
    ids?: {
      mentorId?: string;
      studentId?: string;
      sessionId?: string;
      enrollmentId?: string;
    }
  ) => {
    setActiveModalView(view);
    if (ids) {
      setMentorId(ids.mentorId);
      setStudentId(ids.studentId);
      setSessionId(ids.sessionId);
      setEnrollmentId(ids.enrollmentId);
    }
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setMentorId(undefined);
    setStudentId(undefined);
    setSessionId(undefined);
    setEnrollmentId(undefined);
  };

  return {
    activeModalView,
    isModalOpen: isOpen,
    mentorId,
    studentId,
    sessionId,
    enrollmentId,
    openModal,
    closeModal,
    setActiveModalView,
    setMentorId,
    setStudentId,
    setSessionId,
    setEnrollmentId,
  };
};

export default useDetailsModal;
